export default {"src":"/_next/static/media/lock.1fc8f70d.svg","height":116,"width":90};